"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgTechnician(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M4.902 33.646c.172-5.6 2.607-8.4 7.305-8.4h10.535c.966 0 1.834.137 2.606.41", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M16.92 21.113c4.515 0 8.174-3.552 8.174-7.934 0-4.381-3.66-7.933-8.173-7.933-4.514 0-8.173 3.552-8.173 7.933 0 4.382 3.659 7.934 8.173 7.934zM33.66 32.984c-.005-5.967-.004-8.995.003-9.085 1.339-.741 2.239-2.121 2.239-3.7 0-1.75-1.105-3.256-2.688-3.919v0a.34.34 0 00-.472.314v3.596a.864.864 0 01-.864.864h-.976a.864.864 0 01-.864-.864v-3.638a.306.306 0 00-.422-.283v0c-1.597.658-2.714 2.17-2.714 3.93 0 1.578.899 2.958 2.237 3.7v9.085a2.262 2.262 0 004.521.002v-.002z", stroke: "currentColor", strokeWidth: 2 }, void 0)] }), void 0));
}
exports.default = SvgTechnician;
//# sourceMappingURL=Technician.js.map